import NavListItem from './NavListItem.vue';
export default {
  props: ["navList"],
  components: {
    NavListItem
  }
};